import getEvertransitCookie from './getEvertransitCookie';
export default function getEvertransitAccessToken() {
  var etCookie = getEvertransitCookie();
  return etCookie && etCookie.session;
}